import React, { PureComponent } from 'react';
import { Checkbox, Dropdown as AntdDropdown } from 'antd';
import noop from 'lodash/noop';
import classNames from 'classnames';
import styles from './index.less';

export default class Dropdown extends PureComponent {
  dropDownRenderFunc = (
    overlay,
    onClickBtn,
    btnName,
    disableBtn,
    onClickBatchSelectBtn,
    batchSelectMode,
    batchSelectModeState,
  ) => (
    <div className={styles.dropdown}>
      {overlay}
      <div className={classNames('fr', { 'all-controls': batchSelectMode })}>
        {batchSelectMode && (
          <Checkbox
            className="checkbox-rounded"
            onChange={onClickBatchSelectBtn}
            checked={batchSelectModeState}
            tabIndex={-1}
          >
            Select All
          </Checkbox>
        )}
        <button
          disabled={disableBtn}
          className="button"
          type="button"
          onClick={onClickBtn}
        >
          {btnName}
        </button>
      </div>
    </div>
  );

  render() {
    const {
      multiSelect,
      children,
      onVisibleChange,
      visible,
      overlay,
      trigger,
      onClickBtn,
      btnName,
      onClickBatchSelectBtn,
      batchSelectMode,
      disableBtn,
      batchSelectModeState,
      disableDropmenu,
    } = this.props;
    if (multiSelect) {
      const dropDownMenu = this.dropDownRenderFunc(
        overlay,
        onClickBtn,
        btnName,
        disableBtn,
        onClickBatchSelectBtn,
        batchSelectMode,
        batchSelectModeState,
      );
      return (
        (<AntdDropdown
          overlay={dropDownMenu}
          trigger={trigger}
          onVisibleChange={onVisibleChange}
          open={visible}
          disabled={disableDropmenu}
        >
          {children}
        </AntdDropdown>)
      );
    }
    return (
      <AntdDropdown
        overlay={overlay}
        trigger={trigger}
        disabled={disableDropmenu}
      >
        {children}
      </AntdDropdown>
    );
  }
}

Dropdown.defaultProps = {
  multiSelect: false,
  visible: false,
  trigger: ['click'],
  onVisibleChange: noop,
  onClickBtn: noop,
  btnName: 'Apply',
  onClickBatchSelectBtn: noop,
  batchSelectMode: false,
  disableBtn: false,
  batchSelectModeState: false,
  disableDropmenu: false,
};
